export default "__VITE_ASSET__CkMFuRpR__"